import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesTall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-tall"><path fillRule="evenodd" clipRule="evenodd" d="M5.75 2C4.7835 2 4 2.7835 4 3.75V16.25C4 17.2165 4.7835 18 5.75 18H8V20.25C8 21.2165 8.7835 22 9.75 22H18.25C19.2165 22 20 21.2165 20 20.25V7.75C20 6.7835 19.2165 6 18.25 6H16V3.75C16 2.7835 15.2165 2 14.25 2H5.75ZM9.75 6H14.5V3.75C14.5 3.61193 14.3881 3.5 14.25 3.5H5.75C5.61193 3.5 5.5 3.61193 5.5 3.75V16.25C5.5 16.3881 5.61193 16.5 5.75 16.5H8V7.75C8 6.7835 8.7835 6 9.75 6Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSlidesTall;
